import React, { useContext, useState } from 'react'
import Icons from '../../components/Icons'
import { Context } from "../contexts/AppContext";
 
function CreateNewVideos(props) {
       const { value } = useContext(Context);
      const [appState, setAppState] = value;
       
    
      const openLayoutPage=()=>{
        props.closeCreateNewGalleryPage();
     
        
      }
  return (
    
        
    <button className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded flex gap-2  "  onClick={openLayoutPage}>
    Upload Videos <Icons.Uploads />
    </button>
 
    
  
  )
}

export default CreateNewVideos